import { createApp } from 'vue'
import App from './App.vue'
import './assets/design-tokens.css'

window.Office.onReady(() => {
    createApp(App).mount('#app');
});